import { useQueryClient } from '@tanstack/react-query'

import { Aviso, Cargando } from '../componentes/ui'
import { usePlan } from './api'
import { RevisionDelPlan } from './RevisionDelPlan'

/**
 * El paso «estructura» del alta (plan del CMS dinámico §8.3), en su progreso: el alta está parada
 * esperando a que la persona revise **«Así propongo organizar tu web»**. Al aceptar o descartar,
 * el núcleo sigue con el alta y el progreso vuelve a avanzar solo.
 */
export const EstructuraEnElAlta = ({ plan, puede, alResolver }: { plan: number; puede: boolean; alResolver: () => void }) => {
  const { data, error } = usePlan(plan)
  const cliente = useQueryClient()
  if (error) return <Aviso tono="error">No se ha podido leer la propuesta de estructura. Recarga la página.</Aviso>
  if (!data) return <Cargando que="Leyendo la propuesta" />
  if (data.estado !== 'propuesto') return <Cargando que="Siguiendo con tu web" />
  if (!puede) return <Aviso tono="info">La IA ha propuesto cómo organizar esta web. La revisa quien la está creando; cuando lo haga, el alta seguirá sola.</Aviso>
  return (
    <section aria-labelledby="titulo-estructura" className="mb-6 flex flex-col gap-3">
      <div>
        <h2 className="font-display text-xl font-semibold" id="titulo-estructura">
          Así propongo organizar tu web
        </h2>
        <p className="text-sm text-tenue">Antes de seguir, revisa lo que la IA ha pensado para tu negocio. Puedes quitar lo que sobre y cambiar los nombres; o seguir solo con las páginas de la plantilla.</p>
      </div>
      <RevisionDelPlan
        alResolver={(v) => {
          cliente.setQueryData(['plan-de-estructura', v.id], v)
          alResolver()
        }}
        vista={data}
      />
    </section>
  )
}
